import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 289"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0080FF",
      d: "M250 206.191 136.684 289V161.914l42.656-29.269v70.211l23.365-17.414 23.741 10.374-23.74-10.374V88.184L125 141.722 47.294 88.184v97.258l-23.74 10.373v.001l23.74-10.374 23.366 17.414v-70.211l42.656 29.269V289L0 206.191V0l125 85.774L250 0v206.191ZM217.701 60.332l8.652-16.064v-.002l-8.652 16.066Z"
    }, null, -1)
  ]))]))
}
export default { render: render }